// extracted by mini-css-extract-plugin
export default {"element":"Tooltip__element___J_Bod"};